import { render, staticRenderFns } from "./CreateEditRole.vue?vue&type=template&id=7f4f2c28&"
import script from "./CreateEditRole.vue?vue&type=script&lang=js&"
export * from "./CreateEditRole.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditRole.vue?vue&type=style&index=0&id=7f4f2c28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports